import { render, staticRenderFns } from "./WasteHelpTab.vue?vue&type=template&id=fb666d2a&"
import script from "./WasteHelpTab.vue?vue&type=script&lang=js&"
export * from "./WasteHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports